import Chart from "react-google-charts";
import PrinterImg from "../../Assets/Images/printer.png";
import "./Printer.scss";
import BarChart from "../BarChart";
import LineChart from "../LineChart";
import { printerOptions } from "../../Hooks/Common";
import { useTranslation } from "react-i18next";

const lineChartOptions = {
  elements: {
    line: {
      tension: 0.4, // disables bezier curves
    },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgb(255, 255, 255)",
      titleColor: "#000000",
      borderColor: "#eaeaea",
      borderWidth: "1",
      callbacks: {
        labelTextColor: function (context) {
          return "#333333";
        },
      },
    },
  },
};

const Printer = ({ data }) => {
  const { t } = useTranslation();
  const ValidateColor = (processValue) => {
    let status;
    if (processValue >= 90) {
      // Green
      status = "#3cc480";
    } else if (processValue > 60 && processValue < 90) {
      // Yellow
      status = "#ffc60a";
    } else if (processValue <= 60) {
      // Red
      status = "#ff5544";
    }

    return status;
  };


  const GeneratePrinterData = (data) => {
    return (
      <div className="printer-container">
        <div className="row">
          <div className="col-md-12 col-sm-12 printer-overview-header">
            {t("LT_smt_line_02_spi_latest_wip")}
          </div>
        </div>
        <div className="row">
          {data.conveyors &&
            data.conveyors.map((conveyor, index) => {
              return (
                <div key={`conveyor${index}`} className="col-md-6 col-sm-12 printer-image-card-wrapper">
                  <div className="row">
                    <div className="col-md-8 col-sm-6">
                      <div className="field-container">
                        <div className="field-container-left">{t("LT_timeStamp")}</div>
                        <div className="field-container-right">
                          {conveyor.date}
                        </div>
                      </div>
                      <div className="field-container">
                        <div className="field-container-left">{t("LT_barcode")}</div>
                        <div className="field-container-right">
                          {conveyor.pcb_number}
                        </div>
                      </div>
                      <div className="field-container">
                        <div className="field-container-left">{t("LT_product_name")}</div>
                        <div className="field-container-right">
                          {conveyor.model_number}
                        </div>
                      </div>
                      <div className="field-container">
                        <div className="field-container-left">
                          {t("LT_cycle_time_s")}
                        </div>
                        <div className="field-container-right">
                          {conveyor.process_duration}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 printer-image-card">
                      <img src={PrinterImg} alt="Printer" width="100" />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  const GeneratePrinterCompetedData = (data) => {
    return (
      <div className="printer-container">
        <div className="row">
          <div className="col-12 printer-overview-header">
            {data.statistics[0] && t(data.statistics[0].name)}
          </div>
        </div>
        <div className="row">
          <div className="col-md-5 col-sm-12 printer-linechart-container">
            <div className="printer-overview-header">
              <div className="printer-chart-heading">
                {t(data.statistics[0].name)}
              </div>
              <div className="printer-chart-average">
                {data.statistics[0].total_count} { t("LT_circuits") }
              </div>
            </div>
            <div className='PrinterLineChart' key = {data.statistics[0].name }>
              <LineChart
                lineChartData={data.statistics[0]}
                lineGraphData={data.statistics[0].data}
                chartColor="#82cedf"
                options={lineChartOptions}
              />
            </div>
          </div>
          <div className="col-md-6 col-sm-12 printer-linechart-container">
            <div className="printer-overview-header">
              <div className="printer-chart-heading">
                {t(data.statistics[1].name)}
              </div>
              <div className="printer-chart-average">
                {data.statistics[1].average.toFixed(2)} { t("LT_seconds") }
              </div>
              <div className="printer-trend-heading">
                { t("LT_60_days_trend") }
              </div>
            </div>
            <div className='AverageCycleTime' key = {data.statistics[1].average }>
              <BarChart barchartData={data.statistics[1]}  options={printerOptions} isGeneric={ true } />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="Printer-overview">
      { data && data.statistics && data.statistics.length > 0 && GeneratePrinterData(data)}
      { data && data.statistics && data.statistics.length > 0 && GeneratePrinterCompetedData(data)}
      { data && data.statistics && data.statistics.length <= 0 && <div className='no-data-available'>{t("LT_no_data_available")}</div>} 
    </div>
  );
};

export default Printer;
